import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import IncomeStatementMiddleware from "../../../middleware/modules/report/income-statement";
import PrintIncomeStatement from "../../../components/utilities/print/default/income-statement";

const mapStateToProps = ({ auth, incomeStatement }) => ({
  isAuthenticated: auth.isAuthenticated,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  isProcessing: incomeStatement.isProcessing,
  dataPrint: incomeStatement.printIncomeStatement,
  requestPrint:incomeStatement.requestPrintIncomeStatement
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPrint: (data) => IncomeStatementMiddleware.getPrint(data),
    },
    dispatch
  );
};

class IncomeStatementContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    requestPrint:PropTypes.bool
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
    requestPrint:false
  };

  UNSAFE_componentWillMount() {
    this.props.getPrint(this.props.data);
  }

  render() {
   
    return <PrintIncomeStatement {...this.props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IncomeStatementContainer);
